import { useEffect, useState } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import Select from "react-select";
import { Row, Col } from "reactstrap";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import { getDropDownVal } from "../dropdownUtils";
import CustomLoader from "../static/CustomLoader";
import {
  uploadDocument,
  viewDocument,
  deleteDocument,
} from "../utiles/DocumentService";

const Schedules = ({
  selectedId,
  mode,
  onHide,
  setRefresh,
  auditcodeList,
  selectedauditcodeList,
  usedCodeList,
  statusOptions,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";

  const today = new Date().toISOString().split("T")[0];

  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [auditeecode, setAuditeecode] = useState("");
  const [user, setUser] = useState("");
  const [schstdate, setSchstdate] = useState(today);
  const [schenddate, setSchenddate] = useState(today);
  const [inspectiontype, setInspectiontype] = useState("");
  const [inspectiontitle, setInspectiontitle] = useState("");
  const [actstdate, setActstdate] = useState("");
  const [actenddate, setActenddate] = useState("");
  const [status, setStatus] = useState("");
  const [path, setPath] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [inspectionOptions, setInspectionOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const fetchEmployeeImage = async (empCode, logoName) => {
    setLoading(true);

    try {
      const folderPath = `${orgcode}/schedule_${empCode}`;

      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: logoName,
      });

      if (response.cd === 1) {
        return "";
      }

      if (response) {
        const mimeType = logoName.toLowerCase().endsWith(".pdf")
          ? "application/pdf"
          : "image/jpeg";

        return `data:${mimeType};base64,${response}`;
      }

      return "";
    } catch (err) {
      console.error("Failed to fetch image:", err);
      return "";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedId !== "") {
      axios
        .post(`${apiUrl}schedule/id/${selectedId}`, null, { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            toast.info(response.data.description);
          } else {
            setId(response.data.id);
            setCode(response.data.code);
            setAuditeecode(response.data.auditeecode);
            setUser(response.data.user);
            setSchstdate(response.data.schstdate);
            setSchenddate(response.data.schenddate);
            setInspectiontype(response.data.inspectiontype);
            setInspectiontitle(response.data.inspectiontitle);
            setActstdate(response.data.actstdate);
            setActenddate(response.data.actenddate);
            setStatus(response.data.status);
            setPath(response.data.path);

            if (response.data.path && response.data.code) {
              fetchEmployeeImage(response.data.code, response.data.path).then(
                (url) => {
                  if (url) {
                    setFilePreview(url);
                  }
                },
              );
            }
          }
        })
        .catch((error) => {
          alert("Some issue. Please check with Administrator..!", error);
        });
    }

    fetchInspectionOptions();
  }, []);

  const fetchInspectionOptions = () => {
    try {
      const response = getDropDownVal("INTP");

      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));

      setInspectionOptions(actOption);
    } catch (error) {
      console.log("error");
    }
  };

  function clearFields() {
    setAuditeecode("");
    setUser("");
    setSchstdate(today);
    setSchenddate(today);
    setInspectiontype("");
    setInspectiontitle("");
    setActstdate("");
    setActenddate("");
    setStatus("");
    setPath("");
    setFilePreview(null);
    setErrors({});
  }

  const validateFields = () => {
    let errors = {};

    if (!auditeecode) {
      errors.auditeecode = "Auditee is required...";
    }

    if (!user) {
      errors.user = "User is required...";
    }

    if (!schstdate) {
      errors.schstdate = "Start Date is required...";
    }

    if (!schenddate) {
      errors.schenddate = "End Date is required...";
    }

    if (!inspectiontype) {
      errors.inspectiontype = "Inspection type is required...";
    }

    if (!inspectiontitle) {
      errors.inspectiontitle = "Title is required...";
    }

    if (schstdate && schenddate) {
      const sdate = new Date(schenddate);
      const edate = new Date(schenddate);

      if (sdate > edate) {
        errors.schenddate = "End Date should be greater than Start Date.";
      }
    }

    if (mode === "U") {
      if (!actstdate || actstdate > today) {
        errors.actstdate =
          " Start Date is required and must be less than or equals to today ...";
      }

      if (!actenddate || actenddate > today) {
        errors.actenddate =
          "Actual End Date is required and must be less than or equals to today...";
      }

      if (!status) {
        errors.status = "Status is required...";
      }

      if (status !== 3) {
        errors.status = "Close status is only allowed here...!";
      }

      if (actstdate && actenddate) {
        const sdate = new Date(actstdate);
        const edate = new Date(actenddate);

        if (sdate > edate) {
          errors.actenddate = "End Date should be greater than Start Date.";
        }
      }
    }

    return errors;
  };

  const handlesubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    const fieldErrors = validateFields();

    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    }

    const formData = {
      id: id,
      code: code,
      auditeecode: auditeecode,
      user: user,
      schstdate: schstdate,
      schenddate: schenddate,
      inspectiontype: inspectiontype,
      inspectiontitle: inspectiontitle,
      actstdate: actstdate,
      actenddate: actenddate,
      status: status,
      path: path,
    };

    try {
      if (mode === "A") {
        if (mode === "A") {
          formData.id = 0;
          formData.code = 0;
          formData.status = 1;
        }

        axios
          .post(apiUrl + "schedule", formData, { headers })
          .then((response) => {
            if (response.data.cd === 1) {
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
            } else {
              setSucessMessage(response.data.description);
              setTitle("✔️ Success");
              setShowSucessModal(true);
            }
          });
      } else {
        axios
          .put(apiUrl + "schedule", formData, { headers })
          .then((response) => {
            if (response.data.cd === 1) {
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
            } else {
              setSucessMessage(response.data.description);
              setTitle("✔️ Success");
              setShowSucessModal(true);
            }
          });
      }
    } catch (error) {
      alert("Some issue. Please check with Administrator..!", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const folderPath = `${orgcode}/schedule_${code}`;
    const maxRetries = 3;

    const formData = new FormData();

    formData.append("file", file);

    if (path) {
      const confirmReplace = window.confirm(
        `A file (${path}) already exists. If you proceed, it will be deleted and replaced with the new one.`,
      );

      if (!confirmReplace) {
        return;
      }

      try {
        const response = await deleteDocument({
          projectCode: "Ptw",
          envCode: envCode,
          folderPath: folderPath,
          fileName: path,
        });

        if (response && response.cd === 1) {
          toast.error(response.description);
        }
      } catch (err) {
        console.warn("Failed to delete previous file", err);
        toast.warning("Could not delete previous file.");
      }
    }

    setLoading(true);

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const uploadRes = await uploadDocument({
          file,
          projectCode: "Ptw",
          envCode,
          folderPath,
        });

        if (uploadRes?.cd === 1) {
          toast.error(uploadRes.description);
          setLoading(false);
          return;
        }

        toast.success("Upload successful!");

        setPath(uploadRes);

        const fileUrl = await fetchEmployeeImage(code, file.name);

        setFilePreview(fileUrl);

        break;
      } catch (error) {
        console.warn(`Attempt ${attempt} failed`, error);

        if (attempt === maxRetries) {
          toast.error("Upload failed after multiple attempts.");
        } else {
          await new Promise((resolve) => setTimeout(resolve, 2000 * attempt));
        }
      }
    }

    setLoading(false);
  };

  const handleTnspectionType = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setInspectiontype(selectedTypeValue);
    } else {
      setInspectiontype("");
    }
  };

  const handleStatus = (selectedStatus) => {
    if (selectedStatus) {
      const selectedTypeStatus = selectedStatus.value;
      setStatus(selectedTypeStatus);
    } else {
      setStatus("");
    }
  };

  const handleAudeteeChange = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setAuditeecode(selectedTypeValue);
    } else {
      setAuditeecode("");
    }
  };

  const handleUserChange = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setUser(selectedTypeValue);
    } else {
      setUser("");
    }
  };

  return (
    <>
      {loading && <CustomLoader />}

      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="popupmodal-maindiv">
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label>Auditee</label>
              <Select
                name="Auditee Code"
                isClearable
                required
                value={
                  auditeecode
                    ? (mode === "U"
                        ? auditcodeList
                        : selectedauditcodeList
                      ).find((option) => option.value === auditeecode)
                    : null
                }
                onChange={handleAudeteeChange}
                placeholder="Select Auditee"
                options={mode === "U" ? auditcodeList : selectedauditcodeList}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.auditeecode && (
                <span className="error-message">{errors.auditeecode}</span>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>User</label>
              <Select
                name="user"
                isClearable
                required
                value={
                  user
                    ? usedCodeList.find((option) => option.value === user)
                    : null
                }
                onChange={handleUserChange}
                placeholder="Select Employee"
                options={usedCodeList}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.user && (
                <span className="error-message">{errors.user}</span>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>Schedule Start Date</label>
              <input
                type="date"
                required
                value={schstdate}
                onChange={(e) => setSchstdate(e.target.value)}
                className="form-control"
              />
              {errors.schstdate && (
                <span className="error-message">{errors.schstdate}</span>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>Schedule End Date</label>
              <input
                type="date"
                required
                value={schenddate}
                onChange={(e) => setSchenddate(e.target.value)}
                className="form-control"
              />
              {errors.schenddate && (
                <span className="error-message">{errors.schenddate}</span>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>Inspection Type</label>
              <Select
                name="Inspection Type"
                isClearable
                required
                value={
                  inspectiontype
                    ? inspectionOptions.find(
                        (option) => option.value === inspectiontype,
                      )
                    : null
                }
                onChange={handleTnspectionType}
                placeholder="Select Type"
                options={inspectionOptions}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
              {errors.inspectiontype && (
                <span className="error-message">{errors.inspectiontype}</span>
              )}
            </div>
          </Col>

          <Col md={6}>
            <div className="form-group">
              <label>Inspection Title</label>
              <input
                type="text"
                placeholder="Enter Inspection Title"
                required
                value={inspectiontitle}
                onChange={(e) => setInspectiontitle(e.target.value)}
                className="form-control"
              />
              {errors.inspectiontitle && (
                <span className="error-message">{errors.inspectiontitle}</span>
              )}
            </div>
          </Col>

          {mode === "U" && (
            <>
              <Col md={6}>
                <div className="form-group">
                  <label>Actual Start Date</label>
                  <input
                    type="date"
                    required
                    value={actstdate}
                    onChange={(e) => setActstdate(e.target.value)}
                    className="form-control"
                  />
                  {errors.actstdate && (
                    <span className="error-message">{errors.actstdate}</span>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>Actual End Date</label>
                  <input
                    type="date"
                    required
                    value={actenddate}
                    onChange={(e) => setActenddate(e.target.value)}
                    className="form-control"
                  />
                  {errors.actenddate && (
                    <span className="error-message">{errors.actenddate}</span>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>Status</label>
                  <Select
                    name="Inspection Status"
                    isClearable
                    required
                    value={
                      status
                        ? statusOptions.find(
                            (option) => option.value === status,
                          )
                        : null
                    }
                    onChange={handleStatus}
                    placeholder="Select Status"
                    options={statusOptions}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    classNamePrefix="select"
                  />
                  {errors.status && (
                    <span className="error-message">{errors.status}</span>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="form-group">
                  <label>Attach File</label>

                  <input
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                    accept="image/*,application/pdf"
                  />

                  {filePreview && (
                    <Box
                      sx={{
                        mt: 1,
                        p: 1,
                        border: "1px solid #DCE4EC",
                        borderRadius: "8px",
                        backgroundColor: "#F8FAFC",
                      }}
                    >
                      {path?.toLowerCase().endsWith(".pdf") ? (
                        <embed
                          src={filePreview}
                          type="application/pdf"
                          width="100%"
                          height="280px"
                          style={{
                            border: "1px solid #DCE4EC",
                            borderRadius: "6px",
                          }}
                        />
                      ) : (
                        <Box
                          component="img"
                          src={filePreview}
                          alt="Preview"
                          sx={{
                            display: "block",
                            width: "100%",
                            maxWidth: 260,
                            maxHeight: 180,
                            objectFit: "contain",
                            mx: "auto",
                            borderRadius: "6px",
                          }}
                        />
                      )}
                    </Box>
                  )}
                </div>
              </Col>
            </>
          )}
        </Row>

        <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>
          <button className="btn btn-danger" onClick={clearFields}>
            Reset
          </button>
        </div>
      </div>
    </>
  );
};

export default Schedules;
